<template>

  <v-container fluid class="order-provider-data-sync">

    <!-- Title -->
    <v-row class="pa-0 ma-0">
      <v-col cols="12" class="d-flex align-center">
        <div class="title">Provider Data Sync</div>
        <!-- <div class="m-dash-text">&mdash;</div>
        <div class="provider-logo-container"><leaf-link-logo /></div> -->
      </v-col>
    </v-row>

    <v-row class="pa-0 ma-0">
      <v-col cols="12" xs="12" sm="12" md="12" lg="12" class="">
        <!-- Order Provider Compare -->
        <order-provider-compare-utility
            :order="order"
            :compareOnMount="true"
            :hideCompareAction="false"
            @updated="reloadOrderData" />
      </v-col>
    </v-row>

  </v-container>

</template>

<script>
// import LeafLinkLogo from '@/components/app/LeafLinkLogo'
import OrderProviderCompareUtility from '@/components/orders/OrderProviderCompareUtility'

export default {
  name: 'OrderProviderDataSync',

  components: {
    // LeafLinkLogo,
    OrderProviderCompareUtility
  },

  props: {
    order: {
      type: Object,
      required: true
    }
  },

  data () {
    return {
    }
  },

  computed: {
    // embedClass () {
    //   switch (this.$vuetify.breakpoint.name) {
    //     case 'xs': return 'embed-xs'
    //     case 'sm': return 'embed-sm'
    //     case 'md': return 'embed-md'
    //     default: return 'embed-lg'
    //   }
    // }
  },

  methods: {
    async reloadOrderData (eventType) {
      return this.$parent.reloadOrderData(eventType)
    }
  }
}
</script>

<style scoped>
  .order-provider-data-sync .provider-logo-container {
    padding-left: 5px;
    padding-right: 5px;
    padding-top: 5px;
    border-radius: 2px;
    background-color: #f2f2f2;
  }

  .order-provider-data-sync .m-dash-text {
    color: #9a9a9a;
    padding-top: 3px;
    padding-right: 15px;
    padding-left: 14px;
  }
</style>
